import allowed from '@/core/constants/allowed-roles.constant'

const index = [
  {
    name: 'Dashboards',
    path: '/dashboards',
    component: () => import('@/modules/dashboard/containers/dashboards/dashboard.container.vue'),
    meta: {
      allowedFlag: 'isEnabledDashboards',
      requiresAuth: true,
      layout: 'home',
      module: 'dashboard',
      allowedRoles: [
        ...allowed.dashboard.roles,
      ],
    },
  },
  {
    name: 'Dashboard Viewer',
    path: '/dashboards/:dashboardId',
    component: () => import('@/modules/dashboard/containers/dashboards/dashboard.container.vue'),
    meta: {
      allowedFlag: 'isEnabledDashboards',
      requiresAuth: true,
      layout: 'home',
      module: 'dashboard',
      allowedRoles: [
        ...allowed.dashboard.roles,
      ],
    },
  },
  {
    name: 'Dashboard Pillar View',
    path: '/dashboards/pillar/:pillarId',
    component: () => import('@/modules/dashboard/containers/dashboards/dashboard.container.vue'),
    meta: {
      allowedFlag: 'isEnabledDashboards',
      requiresAuth: true,
      layout: 'home',
      module: 'dashboard',
      allowedRoles: [
        ...allowed.dashboard.roles,
      ],
    },
  },
  {
    name: 'SPS Dashboards',
    path: '/sps-dashboards',
    meta: {
      // allowedRoles: [
      //   'client-administrator',
      //   'safety-observation-dashboard',
      //   'spi-dashboard',
      //   'sc-dashboard',
      //   'wc-dashboard',
      //   'bpo-dashboard',
      //   'tm-dashboard',
      //   'im-dashboard',
      //   'risk-profiling-dashboard',
      // ],
      requiresAuth: true,
      layout: 'home',
      module: 'dashboard',
      allowedRoles: [
        ...allowed.dashboard.roles,
      ],
    },
    children: [
      {
        name: 'Dashboard SPS Viewer',
        path: '/sps-dashboards',
        props: true,
        component: () =>
          import(
            '@/modules/dashboard/containers/sps-dashboard.container.vue'
          ),
      },
    ],
  },
  {
    name: '22 Elements Dashboard',
    path: '/22-elements-dashboard',
    meta: {
      requiresAuth: true,
      layout: 'home',
      module: 'dashboard',
      allowedRoles: [
        ...allowed.dashboard.roles,
      ],
    },
    children: [
      {
        name: '22 Elements Dashboard Viewer',
        path: '/22-elements-dashboard',
        props: true,
        component: () =>
          import(
            '@/modules/dashboard/containers/22-elements-dashboard.container.vue'
          ),
      },
    ],
  },
]

export default index
